import { jsxs as c, Fragment as v, jsx as n } from "@emotion/react/jsx-runtime";
import { B as A } from "../Button/LoadingButton.js";
import { ArrowDropDown as B } from "@mui/icons-material";
import E from "@mui/material/ClickAwayListener";
import L from "@mui/material/Grow";
import O from "@mui/material/MenuItem";
import P from "@mui/material/MenuList";
import R from "@mui/material/Paper";
import T from "@mui/material/Popper";
import { styled as j, alpha as p } from "@mui/material/styles";
import { useState as F, useRef as f, useEffect as K } from "react";
const S = j(P)(({ theme: t }) => ({
  "& .MuiMenuItem-root:not(:last-child)": {
    borderBottom: `1px solid ${p(t.palette.primary.main, 0.5)}`
  },
  "& .MuiMenuItem-root:hover": {
    backgroundColor: p(t.palette.primary.main, 0.1)
  }
}));
function X({
  buttonLabel: t,
  menuItems: d,
  handleClickMenuItem: l,
  placement: m = "bottom-end",
  variant: h = "outlined",
  color: y = "primary",
  sx: b,
  disabled: x,
  startIcon: M,
  size: g
}) {
  const [e, a] = F(!1), i = f(null), w = () => {
    a((r) => !r);
  }, s = (r) => {
    i.current && i.current.contains(r.target) || a(!1);
  }, D = (r, o) => {
    l && (s(r), l(o));
  };
  function k(r) {
    r.key === "Tab" ? (r.preventDefault(), a(!1)) : r.key === "Escape" && a(!1);
  }
  const u = f(e);
  return K(() => {
    u.current === !0 && e === !1 && i.current.focus(), u.current = e;
  }, [e]), /* @__PURE__ */ c(v, { children: [
    /* @__PURE__ */ c(
      A,
      {
        sx: { textTransform: "unset", paddingRight: "0.5rem", ...b },
        ref: i,
        "aria-expanded": e ? "true" : void 0,
        "aria-haspopup": "true",
        "aria-label": t,
        onClick: w,
        variant: h,
        color: y,
        disabled: x,
        startIcon: M,
        size: g,
        children: [
          t,
          /* @__PURE__ */ n(B, {})
        ]
      }
    ),
    /* @__PURE__ */ n(
      T,
      {
        sx: { zIndex: 100 },
        open: e,
        anchorEl: i.current,
        placement: m,
        transition: !0,
        disablePortal: !0,
        children: ({ TransitionProps: r }) => /* @__PURE__ */ n(
          L,
          {
            ...r,
            style: {
              transformOrigin: "left top"
            },
            children: /* @__PURE__ */ n(R, { children: /* @__PURE__ */ n(E, { onClickAway: s, children: /* @__PURE__ */ n(
              S,
              {
                autoFocusItem: e,
                id: "composition-menu",
                "aria-labelledby": "composition-button",
                onKeyDown: k,
                children: d.map((o, C) => /* @__PURE__ */ n(
                  O,
                  {
                    disabled: o.isDisabled,
                    onClick: (I) => D(I, o.value ?? ""),
                    children: (o == null ? void 0 : o.children) ?? (o == null ? void 0 : o.label)
                  },
                  C
                ))
              }
            ) }) })
          }
        )
      }
    )
  ] });
}
export {
  X as D
};
